import {
    ILoginPayload,
    ILogoutPayload,
    ICheckUserPayload,
} from '../user/user.actions';
import { action, payload } from 'ts-action';
import { IFetchCoursesPayload,ICreateCoursePayload } from '../course/course.actions';
import {
    ICreateQuizPayload,
    IFetchQuizzesPayload,
    IFetchQuizPayload,
    IUpdateQuizPayload,
    IDeleteQuizPayload,
} from '../quiz/quiz.actions';
import {
    IFetchQuestionsPayload,
    IInsertQuestionPayload,
    IUpdateQuestionPayload,
    IDeleteQuestionPayload,
    IFetchQuestionPayload,
    IFetchQuestionAnswerPayload
} from '../question/question.actions';
import { IInsertImagesPayload } from '../images/images.action';
import {
    IInsertAnswersPayload,
    IClearAnswersPayload,
} from '../answer/answer.actions';
import {
    IFetchScorePayload,
    IFetchScoresPayload,
    IInsertScorePayload,
} from '../score/score.actions';
import {
    IFetchFeedbacksPayload,
    IInsertFeedbackPayload,
} from '../feedback/feedback.actions';

export type IFetchApiPayload =
    | ILoginPayload
    | ILogoutPayload
    | ICheckUserPayload
    | IFetchCoursesPayload
    | ICreateQuizPayload
    | IFetchQuizPayload
    | IFetchQuizzesPayload
    | IUpdateQuizPayload
    | IDeleteQuizPayload
    | IInsertQuestionPayload
    | IFetchQuestionsPayload
    | IFetchQuestionAnswerPayload
    | IFetchQuestionPayload
    | IUpdateQuestionPayload
    | IDeleteQuestionPayload
    | IInsertImagesPayload
    | IInsertAnswersPayload
    | IInsertScorePayload
    | IFetchScorePayload
    | IFetchScoresPayload
    | IClearAnswersPayload
    | IFetchFeedbacksPayload
    | IInsertFeedbackPayload
    | ICreateCoursePayload;

export type IFetchApiNames =
    | ILoginPayload['name']
    | ILogoutPayload['name']
    | ICheckUserPayload['name']
    | IFetchCoursesPayload['name']
    | ICreateQuizPayload['name']
    | IFetchQuizPayload['name']
    | IFetchQuizzesPayload['name']
    | IUpdateQuizPayload['name']
    | IDeleteQuizPayload['name']
    | IInsertQuestionPayload['name']
    | IFetchQuestionsPayload['name']
    | IFetchQuestionAnswerPayload['name']
    | IFetchQuestionPayload['name']
    | IUpdateQuestionPayload['name']
    | IDeleteQuestionPayload['name']
    | IInsertImagesPayload['name']
    | IInsertAnswersPayload['name']
    | IInsertScorePayload['name']
    | IFetchScorePayload['name']
    | IFetchScoresPayload['name']
    | IClearAnswersPayload['name']
    | IFetchFeedbacksPayload['name']
    | IInsertFeedbackPayload['name']
    | ICreateCoursePayload['name'];

export const FETCH_API = 'FETCH_API';
export const FETCH_API_FAIL = 'FETCH_API_FAIL';
export const FETCH_API_SUCCESS = 'FETCH_API_SUCCESS';

export const fetchApi = action(FETCH_API, payload<IFetchApiPayload>());
export const fetchApiFail = action(
    FETCH_API_FAIL,
    payload<{ name: IFetchApiNames; error: any }>()
);
export const fetchApiSuccess = action(
    FETCH_API_SUCCESS,
    payload<IFetchApiNames>()
);

export type FetchActionType =
    | ReturnType<typeof fetchApi>
    | ReturnType<typeof fetchApiFail>
    | ReturnType<typeof fetchApiSuccess>;
